import axiosPackage from "axios";
import { saveAs } from "file-saver";
import { getStorageAuth } from "../components/_auth/methods";

export const downloadFile = ({ fileUrl, fileName, onStart, onSuccess, onFailed }) => {
  const authStorage = getStorageAuth();
  const headers = authStorage?.access_token
    ? {
        "Authorization": `Bearer ${authStorage.access_token}`,
        google2fa: authStorage.google2fa
      }
    : {};
  onStart?.();
  axiosPackage
    .get(fileUrl, {
      headers,
      responseType: "blob",
      withCredentials: true
    })
    .then(
      (response) => {
        saveAs(response.data, fileName);
        onSuccess?.(response);
      },
      (err) => {
        onFailed?.(err);
      }
    );
};
